import styled, { css } from "styled-components";

import { COLOR, TEXT_COLOR } from "../../../styles/colors";
import { setFontStyle } from "../../../styles/typography";

const container = styled.div<{
  width?: string;
  height?: string;
  disabled?: boolean;
  hasError: boolean;
}>`
  width: ${({ width }) => width || "100%"};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "initial")};

  > label {
    display: inline-flex;
    align-items: center;
    margin-bottom: 4px;
    color: ${TEXT_COLOR.black_2};
    ${setFontStyle("Body3")};
    min-width: max-content;

    ${({ disabled }) => {
      if (disabled) {
        return css`
          color: ${TEXT_COLOR.black_disabled};
          cursor: not-allowed;
        `;
      }
    }}
  }

  > .text-area-container {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;

    > textarea {
      padding: 16px;
      width: 100%;
      height: ${({ height }) => `calc(${height} - 2px)` || "auto"};
      border-radius: 2px;
      border: 1px solid ${COLOR.grayScale_400};
      background-color: ${COLOR.wh};
      color: ${TEXT_COLOR.black_2};
      ${setFontStyle("Body2")};
      background-color: ${COLOR.wh};
      resize: none;

      ${({ hasError }) => {
        if (hasError) {
          return css`
            border: 1px solid ${COLOR.error_200};
          `;
        }
      }};

      ${({ disabled }) => {
        if (disabled) {
          return css`
            color: ${TEXT_COLOR.black_disabled};
            background-color: ${COLOR.grayScale_100};
            border: 1px solid ${COLOR.grayScale_300};
            cursor: not-allowed;
          `;
        }
      }}

      &:focus {
        border: 1px solid ${COLOR.primary_900};

        ${({ hasError }) => {
          if (hasError) {
            return css`
              border: 1px solid ${COLOR.error_200};
            `;
          }
        }}

        ${({ disabled }) => {
          if (disabled) {
            return css`
              border: 1px solid ${COLOR.grayScale_300};
            `;
          }
        }};
      }

      &::placeholder {
        color: ${TEXT_COLOR.black_5};
      }
    }
  }

  > .error-message {
    margin-top: 2px;
    margin-left: 16px;
    color: ${COLOR.error_400};
    ${setFontStyle("Body5")};
  }
`;

export default {
  container,
};
